export const SET_SIMILAR_IMAGE_DIALOG = 'SET_SIMILAR_IMAGE_DIALOG';
export const SET_SIMILAR_IMAGES_FILTERS = 'SET_SIMILAR_IMAGES_FILTERS';
export const RESET_SIMILAR_IMAGE_DIALOG = 'RESET_SIMILAR_IMAGE_DIALOG';
export const SET_DIALOG_VARIANT = 'SET_DIALOG_VARIANT';
export const SET_SIMILAR_IMAGE_LOADING = 'SET_SIMILAR_IMAGE_LOADING';
